(function () {
  'use strict';

  /* Menu mobile */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('no-scroll', open);
    });
    nav.querySelectorAll('.has-sub > a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 989px)').matches) {
          e.preventDefault();
          a.parentElement.classList.toggle('is-open');
        }
      });
    });
  }

  /* Galleria prodotto: click sulle miniature */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = gallery.querySelector('[data-media-id="' + thumb.dataset.target + '"]');
        if (target && main) {
          main.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  });

  /* Ordinamento collezione */
  var sort = document.querySelector('[data-sort-by]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Selettore paese/lingua */
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  /* Avvia i video in autoplay che il browser potrebbe aver messo in pausa */
  document.querySelectorAll('video[autoplay]').forEach(function (v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  });
})();
